import styled from 'styled-components';
import colors from '../../../../helpers/colors';
import fonts from '../../../../helpers/fonts';
import mediaQuery from '../../../../helpers/mediaQuery';
import spacing from '../../../../helpers/spacing';
import { PrimaryCta } from '../../../Cta';

export const CardSectionContainer = styled.div`
  padding: ${spacing(3)};
  background-color: ${colors.core01};

  ${mediaQuery.tabletLandscape`
    padding: ${spacing(2)} ${spacing(3)};
  `};
`;

export const CardSectionHeading = styled.h4`
  ${fonts.headingXSmall};

  margin: 0;
  color: ${colors.neutral08};

  ${mediaQuery.tabletLandscape`
    text-align: center;
  `};
`;

export const CardSectionText = styled.p`
  ${fonts.paragraphSmall};

  margin: ${spacing(1)} 0 0 0;
  color: ${colors.neutral08};

  ${mediaQuery.tabletLandscape`
    text-align: center;
  `};
`;

export const CardSectionCta = styled(PrimaryCta)`
  height: auto;
  margin-top: ${spacing(3)};
  padding: ${spacing(2)};

  ${mediaQuery.tabletLandscape`
    width: 100%;    
  `};
`;
